import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Admin/Dashboard/dashboard.scss';
import { LocaleContext } from 'routes/Router';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useIntl } from 'react-intl';

const EnterprisePatients = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
            : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
        }
      >
        EnterprisePatients
      </Col>
    </Row>
  );
};

export default EnterprisePatients;
